export class SmsStatistic {

    private centerInternalId: string;
    private centerName: string;
    private companyInternalId: string;
    private counterError: number;
    private counterOk: number;
    private smsOrigin: string;
    private statsDate: number;

    constructor(centerInternalId?: string, centerName?: string, companyInternalId?: string, counterError?: number, counterOk?: number, smsOrigin?: string, statsDate?: number) {
        this.centerInternalId = centerInternalId;
        this.centerName = centerName;
        this.companyInternalId = companyInternalId;
        this.counterError = counterError;
        this.counterOk = counterOk;
        this.smsOrigin = smsOrigin;
        this.statsDate = statsDate;
    }

    public get CenterInternalId() {
        return this.centerInternalId;
    }
    public get CenterName() {
        return this.centerName;
    }
    public get CompanyInternalId() {
        return this.companyInternalId;
    }
    public get CounterError() {
        return this.counterError;
    }
    public get CounterOk() {
        return this.counterOk;
    }
    public get SmsOrigin() {
        return this.smsOrigin;
    }
    public get StatsDate() {
        return this.statsDate;
    }
    public set CenterInternalId(centerInternalId) {
        this.centerInternalId = centerInternalId;
    }
    public set CenterName(centerName) {
        this.centerName = centerName;
    }
    public set CompanyInternalId(companyInternalId) {
        this.companyInternalId = companyInternalId;
    }
    public set CounterError(counterError) {
        this.counterError = counterError;
    }
    public set CounterOk(counterOk) {
        this.counterOk = counterOk;
    }
    public set SmsOrigin(smsOrigin) {
        this.smsOrigin = smsOrigin;
    }
    public set StatsDate(statsDate) {
        this.statsDate = statsDate;
    }
}
